import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import { Navigate } from "react-router-dom";

function DatosPrestador() {
  const cookies = new Cookies();

  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const tipoCampo = "TIPO DE IDENTIFICACIÓN";

  const [tiposDocumento, setTiposDocumento] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [verContrasena, setVerContrasena] = useState(false);
  const [municipios, setMunicipios] = useState([]);
  const [userName, setUserName] = useState("");
  const [rol, setRol] = useState("");

  const [form, setForm] = useState({
    razonSocial: "",
    tipoIdentificacion: "",
    nit: "",
    dv: "",
    codigoHabilitacion: "",
    direccion: "",
    telefono: "",
    correoElectronico: "",
    codigoDepartamento: "",
    codigoMunicipio: "",
    usuMod: userName,
  });
  const [formSispro, setFormSispro] = useState({
    tipoDoc: "",
    numDoc: "",
    contrasena: "",
    nit: "",
  });

  ///Validar campos obligatorios
  const validarCampos = () => {
    const camposObligatorios = [
      { campo: "razonSocial", label: "Razón Social" },
      { campo: "tipoIdentificacion", label: "Tipo de Identificación" },
      { campo: "codigoHabilitacion", label: "Código de Habilitación" },
      { campo: "correoElectronico", label: "Correo Electrónico" },
      { campo: "telefono", label: "Teléfono" },
      { campo: "direccion", label: "Dirección" },
      { campo: "codigoDepartamento", label: "Departamento" },
      { campo: "codigoMunicipio", label: "Municipio" },
    ];

    for (const { campo, label } of camposObligatorios) {
      if (!form[campo] || form[campo].trim() === "") {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          title: `El campo "${label}" es obligatorio`,
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return false;
      }
    }

    const camposSispro = [
      { campo: "tipoDoc", label: "Tipo de documento SISPRO" },
      { campo: "numDoc", label: "Número documento SISPRO" },
      { campo: "contrasena", label: "Contraseña SISPRO" },
    ];

    for (const { campo, label } of camposSispro) {
      if (!formSispro[campo] || formSispro[campo].trim() === "") {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          title: `El campo "${label}" es obligatorio`,
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return false;
      }
    }

    return true;
  };

  //Guardar los datos del formulario de datos del prestador
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  //Guardar los datos del formulario de datos del sispro
  const handleInputChangeSispro = (e) => {
    const { name, value } = e.target;
    setFormSispro((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  //Al iniciar el formulario, load
  useEffect(() => {
    setUserName(cookies.get("nombreUsuario") || "");
    setRol(cookies.get("rol") || "");

    // 1. Cargar tipos de documento
    axios
      .get(baseURL + `/api/Listas/ListarDatos/${encodeURIComponent(tipoCampo)}`)
      .then((response) => {
        setTiposDocumento(response.data);
      })
      .catch((error) => {
        console.error("Error al cargar tipos documento:", error);
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: "Error al cargar tipos de documento",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      });

    // 2. Cargar departamentos
    axios
      .get(baseURL + `/api/Listas/ListarDepartamentos`)
      .then((response) => {
        setDepartamentos(response.data);
      })
      .catch((error) => {
        console.error("Error al cargar departamentos:", error);
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: "Error al cargar departamentos",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      });

    // 3. Cargar datos actuales del prestador y SISPRO
    axios
      .get(baseURL + `/api/Empresa/ConsultarDatosPrestador`)
      .then((response) => {
        const { exito, datosPrestador, datosSispro } = response.data;

        if (exito) {
          if (datosPrestador) {
            setForm((prev) => ({
              ...prev,
              ...datosPrestador,
            }));
          }

          if (datosSispro) {
            setFormSispro((prev) => ({
              ...prev,
              ...datosSispro,
            }));
          }
        }
      })
      .catch((error) => {
        console.error("Error al consultar datos del prestador:", error);
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: "Error al consultar datos del prestador",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      });
  }, []);

  //API para consultar los municipios , cuando cambia el departamento
  useEffect(() => {
    if (!form.codigoDepartamento) return;

    // Limpia el campo municipios
    setForm((prev) => ({ ...prev, codigoMunicipio: "" }));
    setMunicipios([]);

    axios
      .get(baseURL + `/api/Listas/ListarMunicipios/${form.codigoDepartamento}`)
      .then((response) => {
        console.log("Municipios:", response.data);
        setMunicipios(response.data);
      })
      .catch((error) => {
        console.error("Error al consumir la API de municipios:", error);
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: "Error al cargar municipios",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      });
  }, [form.codigoDepartamento]);

  //API para guardar los datos del prestador
  const guardarDatosPrestador = async () => {
    try {
      const response = await axios.post(
        baseURL + "/api/Empresa/ActualizarDatosPrestador",
        form
      );

      const { exito, mensaje } = response.data;

      if (!exito) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          title: mensaje,
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return false;
      }

      return true;
    } catch (error) {
      console.error("Error al guardar prestador:", error);
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Error al conectar con el servidor",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      return false;
    }
  };

  //API para guardar los datos de sispro
  const guardarDatosSispro = async () => {
    try {
      const response = await axios.post(
        baseURL + "/api/Empresa/ActualizarDatosSispro",
        formSispro
      );

      const { exito, mensaje } = response.data;

      if (!exito) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          title: mensaje,
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return false;
      }

      return true;
    } catch (error) {
      console.error("Error al guardar SISPRO:", error);
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Error al conectar con el servidor",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      return false;
    }
  };

  //Actulizar los datos de la empresa y sispro
  const actualizarDatos = async () => {
    if (!validarCampos()) return;

    const prestadorGuardado = await guardarDatosPrestador();
    if (!prestadorGuardado) return;

    const sisproGuardado = await guardarDatosSispro();
    if (!sisproGuardado) return;

    Swal.fire({
      icon: "success",
      title: "Éxito",
      text: "Datos guardados correctamente.",
    });
  };


  //SI el usuario logueado no es rol ADMIN lo redirecciona
  if (rol && rol !== "Admin") {
    return <Navigate to="/inicio" />;
  }

  //HTML
  return (
    <div className="content">
      <div className="container-fluid">
        {/* Datos del Prestador */}
        <div className="card">
          <div className="card-header bg-gray text-white">
            <h3 className="card-title text-white">🏥 Datos del prestador</h3>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-4 mb-2">
                <label>
                  Razón social <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="razonSocial"
                  autoComplete="off"
                  value={form.razonSocial}
                  onChange={handleInputChange}
                  className="form-control"
                />
              </div>

              <div className="col-md-4">
                <label>
                  Tipo documento <span className="text-danger">*</span>
                </label>
                <select
                  name="tipoIdentificacion"
                  value={form.tipoIdentificacion}
                  onChange={handleInputChange}
                  className="form-control"
                >
                  <option value="">Seleccione</option>
                  {tiposDocumento.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.value + " - " + item.nomCampo}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-2">
                <label>
                  NIT <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="nit"
                  disabled
                  value={form.nit}
                  maxLength={15}
                  onChange={(e) => {
                    handleInputChange(e);
                    handleInputChangeSispro(e);
                  }}
                  onKeyDown={(e) => {
                    if (
                      !/[0-9]/.test(e.key) &&
                      ![
                        "Backspace",
                        "Tab",
                        "ArrowLeft",
                        "ArrowRight",
                        "Delete",
                      ].includes(e.key)
                    ) {
                      e.preventDefault();
                    }
                  }}
                  className="form-control"
                />
              </div>

              <div className="col-md-2">
                <label>DV</label>
                <input
                  type="text"
                  name="dv"
                  autoComplete="off"
                  value={form.dv}
                  maxLength={1}
                  onChange={handleInputChange}
                  onKeyDown={(e) => {
                    if (
                      !/[0-9]/.test(e.key) &&
                      ![
                        "Backspace",
                        "Tab",
                        "ArrowLeft",
                        "ArrowRight",
                        "Delete",
                      ].includes(e.key)
                    ) {
                      e.preventDefault();
                    }
                  }}
                  className="form-control"
                />
              </div>

              <div className="col-md-4 mb-2">
                <label>
                  Código habilitación <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="codigoHabilitacion"
                  autoComplete="off"
                  value={form.codigoHabilitacion}
                  maxLength={15}
                  onChange={handleInputChange}
                  onKeyDown={(e) => {
                    if (
                      !/[0-9]/.test(e.key) &&
                      ![
                        "Backspace",
                        "Tab",
                        "ArrowLeft",
                        "ArrowRight",
                        "Delete",
                      ].includes(e.key)
                    ) {
                      e.preventDefault();
                    }
                  }}
                  className="form-control"
                />
              </div>

              <div className="col-md-4">
                <label>
                  Correo electrónico <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  autoComplete="off"
                  name="correoElectronico"
                  value={form.correoElectronico}
                  onChange={handleInputChange}
                  className="form-control"
                />
              </div>

              <div className="col-md-4">
                <label>
                  Teléfono <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="telefono"
                  autoComplete="off"
                  value={form.telefono}
                  onChange={handleInputChange}
                  className="form-control"
                />
              </div>

              <div className="col-md-4">
                <label>
                  Dirección <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="direccion"
                  autoComplete="off"
                  value={form.direccion}
                  onChange={handleInputChange}
                  className="form-control"
                />
              </div>

              <div className="col-md-4">
                <label>
                  Departamento <span className="text-danger">*</span>
                </label>
                <select
                  name="codigoDepartamento"
                  value={form.codigoDepartamento}
                  onChange={handleInputChange}
                  className="form-control"
                >
                  <option value="">Seleccione</option>
                  {departamentos.map((item) => (
                    <option key={item.codDepa} value={item.codDepa}>
                      {item.departamento}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-4">
                <label>
                  Municipio <span className="text-danger">*</span>
                </label>
                <select
                  name="codigoMunicipio"
                  value={form.codigoMunicipio}
                  onChange={handleInputChange}
                  className="form-control"
                >
                  <option value="">Seleccione</option>
                  {municipios.map((item) => (
                    <option key={item.codMun} value={item.codMun}>
                      {item.municipio}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Datos de Conexión SISPRO */}
      <div className="card">
        <div className="card-header bg-gray text-white">
          <h3 className="card-title text-white">🔐 Datos de conexión SISPRO</h3>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label>
                  Tipo documento <span className="text-danger">*</span>
                </label>
                <select
                  name="tipoDoc"
                  value={formSispro.tipoDoc}
                  onChange={handleInputChangeSispro}
                  className="form-control"
                >
                  <option value="">Seleccione</option>
                  {tiposDocumento.map((item) => (
                    <option key={item.nomCampo} value={item.value}>
                      {item.value + " - " + item.nomCampo}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>
                  Número documento <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="numDoc"
                  value={formSispro.numDoc}
                  onChange={handleInputChangeSispro}
                  maxLength={15}
                  className="form-control"
                  onKeyDown={(e) => {
                    const allowed = [
                      "Backspace",
                      "Tab",
                      "ArrowLeft",
                      "ArrowRight",
                      "Delete",
                    ];
                    if (!/[0-9]/.test(e.key) && !allowed.includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>
                  Contraseña <span className="text-danger">*</span>
                </label>
                <input
                  type={verContrasena ? "text" : "password"}
                  name="contrasena"
                  value={formSispro.contrasena}
                  onChange={handleInputChangeSispro}
                  autoComplete="off"
                  className="form-control"
                  style={{ paddingRight: "2.5rem" }}
                />

                <span
                  onClick={() => setVerContrasena(!verContrasena)}
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "60%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#6c757d",
                  }}
                >
                  <i
                    className={`fas ${
                      verContrasena ? "fa-eye-slash" : "fa-eye"
                    }`}
                  ></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Botón Guardar */}
      <div className="row mt-2">
        <div className="col-12 text-center">
          <button
            className="btn btn-sm btn-success shadow rounded-pill mb-1 px-3"
            onClick={() => actualizarDatos()}
          >
            <i className="fas fa-save mr-1"></i>
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
}

export default DatosPrestador;
